// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_howToRegisterSection__1-RWp {
  background-color: var(--background-color0);
  padding: 6rem 0;
}

.styles_sectionTitle__KUUvF {
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
  color: var(--text-color0);
  margin-bottom: 1rem;
}

.styles_divider__LkGTY {
  width: 5rem;
  height: 4px;
  background-color: var(--brand-yellow);
  border: none;
  border-radius: 2px;
  margin: 1.5rem auto 3.5rem auto;
}

.styles_stepsList__wCcwL {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
  max-width: 45rem;
  margin: 3rem auto 0 auto;
  padding: 0;
  list-style: none;
  position: relative;
}

.styles_highlight__hXIiN {
  color: var(--brand-yellow);
}

.styles_stepsList__wCcwL::before {
  content: '';
  position: absolute;
  top: 1.75rem;
  bottom: 1.75rem;
  left: 1.75rem;
  width: 2px;
  background: repeating-linear-gradient(to bottom, var(--brand-yellow), var(--brand-yellow) 6px, transparent 6px, transparent 12px);
  opacity: 0.3;
  z-index: 1;
}

@media (max-width: 600px) {
  .styles_stepsList__wCcwL::before {
    left: 50%;
    transform: translateX(-50%);
  }
}

.styles_stepItem__rz-GU {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  position: relative;
  z-index: 2;
}

@media (max-width: 600px) {
  .styles_stepItem__rz-GU {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1rem;
  }
}

.styles_stepBadge__TTwcG {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 800;
  font-size: 1.5rem;
  box-shadow: 0 4px 10px rgba(var(--brand-yellow-rgb), 0.3);
  flex-shrink: 0;
  transition: transform 0.3s ease;
}

.styles_stepItem__rz-GU:hover .styles_stepBadge__TTwcG {
  transform: scale(1.1);
}

.styles_stepTextWrapper__GzC1I {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 0.4rem;
}

@media (max-width: 600px) {
  .styles_stepTextWrapper__GzC1I {
    padding-top: 0;
  }
}

.styles_stepTitle__Caouv {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-color0);
  margin: 0;
}

.styles_stepDesc__6g9yo {
  font-size: 1.05rem;
  color: var(--text-color1);
  line-height: 1.6;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/CadastroLoja/components/HowToRegisterSection/styles.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,UAAU;EACV,iIAAiI;EACjI,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;IACT,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2FAA2F;EAC3F,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yDAAyD;EACzD,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX","sourcesContent":[".howToRegisterSection {\n  background-color: var(--background-color0);\n  padding: 6rem 0;\n}\n\n.sectionTitle {\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n  color: var(--text-color0);\n  margin-bottom: 1rem;\n}\n\n.divider {\n  width: 5rem;\n  height: 4px;\n  background-color: var(--brand-yellow);\n  border: none;\n  border-radius: 2px;\n  margin: 1.5rem auto 3.5rem auto;\n}\n\n.stepsList {\n  display: flex;\n  flex-direction: column;\n  gap: 3.5rem;\n  max-width: 45rem;\n  margin: 3rem auto 0 auto;\n  padding: 0;\n  list-style: none;\n  position: relative;\n}\n\n.highlight {\n  color: var(--brand-yellow);\n}\n\n.stepsList::before {\n  content: '';\n  position: absolute;\n  top: 1.75rem;\n  bottom: 1.75rem;\n  left: 1.75rem;\n  width: 2px;\n  background: repeating-linear-gradient(to bottom, var(--brand-yellow), var(--brand-yellow) 6px, transparent 6px, transparent 12px);\n  opacity: 0.3;\n  z-index: 1;\n}\n\n@media (max-width: 600px) {\n  .stepsList::before {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n}\n\n.stepItem {\n  display: flex;\n  align-items: flex-start;\n  gap: 2rem;\n  position: relative;\n  z-index: 2;\n}\n\n@media (max-width: 600px) {\n  .stepItem {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 1rem;\n  }\n}\n\n.stepBadge {\n  width: 3.5rem;\n  height: 3.5rem;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-hover) 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 800;\n  font-size: 1.5rem;\n  box-shadow: 0 4px 10px rgba(var(--brand-yellow-rgb), 0.3);\n  flex-shrink: 0;\n  transition: transform 0.3s ease;\n}\n\n.stepItem:hover .stepBadge {\n  transform: scale(1.1);\n}\n\n.stepTextWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding-top: 0.4rem;\n}\n\n@media (max-width: 600px) {\n  .stepTextWrapper {\n    padding-top: 0;\n  }\n}\n\n.stepTitle {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--text-color0);\n  margin: 0;\n}\n\n.stepDesc {\n  font-size: 1.05rem;\n  color: var(--text-color1);\n  line-height: 1.6;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"howToRegisterSection": `styles_howToRegisterSection__1-RWp`,
	"sectionTitle": `styles_sectionTitle__KUUvF`,
	"divider": `styles_divider__LkGTY`,
	"stepsList": `styles_stepsList__wCcwL`,
	"highlight": `styles_highlight__hXIiN`,
	"stepItem": `styles_stepItem__rz-GU`,
	"stepBadge": `styles_stepBadge__TTwcG`,
	"stepTextWrapper": `styles_stepTextWrapper__GzC1I`,
	"stepTitle": `styles_stepTitle__Caouv`,
	"stepDesc": `styles_stepDesc__6g9yo`
};
export default ___CSS_LOADER_EXPORT___;
